import { useTranslation } from 'react-i18next';
import { Box, Divider } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';

import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';
import {
  Header,
  ModalContainer,
} from '@core/dashboard/components/PopoverModal';
import ScrollableContainer from '@components/ScrollableContainer';
import { useTooltipGuideModal } from './context';
import useTooltipGuide from './useTooltipGuide';

import { useStyles } from './styles';
import { useMytaverseEvent } from '@core/dashboard/providers';

const TooltipGuide = () => {
  const { open, setOpen, toggleOpen } = useTooltipGuideModal();
  const { currentEvent } = useMytaverseEvent();

  const {
    Camera,
    Microphone,
    ToggleView,
    Assistant,
    EventScheduler,
    Chat,
    Community,
    Tools,
    Reactions,
    FullScreen,
    Profile,
    Teleport,
    CollapseExpand,
    PlaceHolder,
  } = useTooltipGuide();

  const isSchedulerHidden =
    !currentEvent?.inviteSlotsTags || currentEvent.inviteSlotsTags.length === 0;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  const renderContent = () => {
    if (isMobileOnly) {
      return (
        <>
          <Box sx={classes.column}>
            {Camera}
            {Microphone}
            {ToggleView}
            {Assistant}
          </Box>
          <Divider orientation="vertical" flexItem sx={classes.divider} />
          <Box sx={classes.column}>
            {isSchedulerHidden ? null : EventScheduler}
            {Chat}
            {Community}
            {Tools}
            {isSchedulerHidden && PlaceHolder}
          </Box>
          <Divider orientation="vertical" flexItem sx={classes.divider} />
          <Box sx={classes.column}>
            {Reactions}
            {Teleport}
            {Profile}
            {CollapseExpand}
          </Box>
        </>
      );
    }

    return (
      <>
        <Box sx={classes.column}>
          {Camera}
          {Microphone}
          {ToggleView}
          {isSchedulerHidden ? null : EventScheduler}
          {Chat}
          {Assistant}
        </Box>
        <Divider orientation="vertical" flexItem sx={classes.divider} />
        <Box sx={classes.column}>
          {Community}
          {Tools}
          {Reactions}
          {FullScreen}
          {Profile}
        </Box>
      </>
    );
  };

  return (
    <SwipeableDrawer
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      open={open}
      onClose={toggleOpen}
      onOpen={() => setOpen(true)}
      sx={isMobileOnly ? classes.drawer : {}}
    >
      <ModalContainer
        isScrollable={false}
        header={
          <Header
            text={translate('tooltips.iconsGuide')}
            onClose={toggleOpen}
            isBig
          />
        }
        sx={classes.container(isMobileOnly)}
      >
        <ScrollableContainer
          sxProps={{
            root: classes.scrollable,
            content: classes.scrollableContent,
          }}
        >
          <Box sx={classes.root}>{renderContent()}</Box>
        </ScrollableContainer>
      </ModalContainer>
    </SwipeableDrawer>
  );
};

export default TooltipGuide;
